import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Category = ({ children, style, active }) => (
  <div className={classNames('services-import__list-category', { 'services-import__list-category-checked': active })} style={style}>
    {children}
  </div>
);

Category.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  active: PropTypes.bool,
};
export default Category;
